import type { AnyBlock } from "@/types";

/** CD VR section — a full-bleed band with a background photo, a left-to-right
 *  scrim and white copy over it. Renders its own full-bleed <section> (the
 *  renderer skips the band wrapper for this block so the image fills edge to
 *  edge). Fixed-layout designed section; copy + image come from props. */
interface CdVrProps {
  eyebrow?: string;
  heading?: string;
  paragraphs?: string[];
  image_url?: string;
}

const DEFAULTS = {
  eyebrow: "Optional service",
  heading: "Experience your extension in full VR.",
  paragraphs: [
    "Many clients find it hard to visualise how their extension will look from two-dimensional drawings alone. Our optional virtual reality service lets you take a walk around your new home before a single brick has been laid.",
    "Experience the new space at real-world scale, move around freely, and decide whether any changes are needed before the builder is involved.",
  ],
  image_url: "/cd/vr.jpeg",
};

export function CdVrBlock({ block }: { block: AnyBlock }) {
  const p = (block.props ?? {}) as CdVrProps;
  const paragraphs = p.paragraphs ?? DEFAULTS.paragraphs;

  return (
    // data-section-key sits on the block's own root because this is a FULL_BLEED block — it
    // skips the band wrapper that stamps the key for everything else.
    <section className="block cd-vr" data-section-key="cd_vr">
      <img className="cd-vr__img" src={p.image_url ?? DEFAULTS.image_url} alt="" loading="lazy" />
      <div className="cd-vr__scrim" aria-hidden="true" />
      <div className="cd-vr__inner">
        <p className="eyebrow cd-vr__eyebrow">{p.eyebrow ?? DEFAULTS.eyebrow}</p>
        <h2 className="cd-vr__title">{p.heading ?? DEFAULTS.heading}</h2>
        {paragraphs.map((para, i) => (
          <p className="cd-vr__p" key={i}>{para}</p>
        ))}
      </div>
    </section>
  );
}
